import styled from 'styled-components'
import { Button as BootstrapButton } from 'reactstrap'

const Button = styled(BootstrapButton)`
  height: 30px;
  padding: 0 16px;

  display: inline-flex;
  align-items: center;

  font-size: 13px;
  font-family: 'Gotham-Medium';
  line-height: 31px;

  &:disabled {
    color: #ededed;
    border-color: #cccccc;
  }
`

export default Button



// WEBPACK FOOTER //
// ./src/lib/components/Button.jsx